import { CommonMessage } from './CommonMessage';
import { MessageType } from './MessageType';

export interface JoinPayload {
  i: number;
  topic: string;
  parameters?: { [key: string]: any };
  metadata?: { [key: string]: any };
  accessToken?: string;
}

export class JoinMessage implements CommonMessage {
  t = MessageType.JOIN;
  public d: JoinPayload;

  constructor(payload: JoinPayload) {
    this.d = payload;
  }
}
